var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClosePaymentError = function SvgClosePaymentError(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.861766 0.361888C1.12212 0.101539 1.54423 0.101539 1.80458 0.361888L15.1379 13.6952C15.3983 13.9556 15.3983 14.3777 15.1379 14.638C14.8776 14.8984 14.4554 14.8984 14.1951 14.638L0.861766 1.3047C0.601417 1.04435 0.601417 0.622238 0.861766 0.361888Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1377 0.361888C14.8774 0.101539 14.4553 0.101539 14.1949 0.361888L0.861604 13.6952C0.601254 13.9556 0.601254 14.3777 0.861604 14.638C1.12195 14.8984 1.54406 14.8984 1.80441 14.638L15.1377 1.3047C15.3981 1.04435 15.3981 0.622238 15.1377 0.361888Z",
    fill: "#EA4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosePaymentError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-payment-error.27675ae5.svg";
export { ForwardRef as ReactComponent };